import React from "react";
import PropTypes from "prop-types";

import {
  CardCVV,
  CardExpiry,
  CardNumber,
} from "@chargebee/chargebee-js-react-wrapper";

import Form from "components/Form";

import { FormField } from "./FormField";

export function CreditCardFields({ disabled }) {
  return (
    <React.Fragment>
      <FormField label="Card Number">
        <CardNumber placeholder="1234 5678 9012 3456" disabled={disabled} />
      </FormField>

      <Form.FieldGroup>
        <FormField label="Expiry Date">
          <CardExpiry disabled={disabled} />
        </FormField>
        <FormField label="Security Code">
          <CardCVV placeholder="CVV" disabled={disabled} />
        </FormField>
      </Form.FieldGroup>
    </React.Fragment>
  );
}

CreditCardFields.propTypes = { disabled: PropTypes.bool };
CreditCardFields.defaultProps = { disabled: false };

export default CreditCardFields;
